import { client, WLClient } from '../../config';
import { store } from '../../stores/store';
import {
  ClientConfig,
  ClientSpecificFeatures,
  ClientSpecificFeaturesStyling,
} from './config';

export const isMeest = (value: WLClient) => value === 'meest';

export const isFeatureRequired = (
  feature: ClientSpecificFeatures | ClientSpecificFeaturesStyling,
  countryCode: string | undefined = store.localizationsStore.selectedCountry
    ?.country_code,
  clientName: WLClient = client
) => {
  const supportedCountries = ClientConfig[feature][clientName];
  if (!supportedCountries) return false;

  if (supportedCountries.length === 0 || !countryCode) return true;

  return supportedCountries.includes(countryCode);
};
